import { createContext, useContext, type ReactNode } from 'react'
import type { AccountSource } from './accountSource'
import { supabaseAccountSource } from './supabaseAccountSource'

// Default is Supabase: the app needs no provider, and tests that mock the Supabase modules keep working.
const AccountSourceContext = createContext<AccountSource>(supabaseAccountSource)

/**
 * Hands an account source to everything below — Storybook and tests pass
 * `createMemoryAccountSource(…)`. Keep `source` stable for the lifetime of the tree.
 */
export function AccountSourceProvider({ source, children }: { source: AccountSource; children: ReactNode }) {
  return <AccountSourceContext.Provider value={source}>{children}</AccountSourceContext.Provider>
}

/** The account source for this part of the tree (Supabase unless a provider says otherwise). */
export function useAccountSource(): AccountSource {
  return useContext(AccountSourceContext)
}
